import { useEffect, useState } from 'react';
import SpendChartWrapper from '../SpendChart/SpendChartWrapper';
import {
  CHART_COLORS,
  CHART_DATASETS,
  RENAME_MAP,
  SEP_PLAN_TAB_LABELS
} from '../../shared/AppConstants';
import { Box, Button, Card, Tooltip } from '@mui/material';
import { useUserInfo } from '../../shared/UserInfo';
import { useSelector } from 'react-redux';
import { getSepSpendGraphData } from '../SpendChart/SpendUtils';
import { SepSpendTable } from './spendTable/SepSpendTable';
import { transformSpendDataForTable } from '../../shared/spendUtils';
import { exportSepPartsToExcel } from './SepPartsExportUtils';

export const SepSpendDisplays = ({ commonProps }) => {
  const { userId } = useUserInfo();
  const spendGraphData = useSelector((state) => state.strategy.spendGraphData);
  const { isEdit = false } = commonProps || {};
  const [updatedSpendGraphData, setUpdatedSpendGraphData] = useState([]);
  const [sepPartsData, setSepPartsData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const { strategyNumber } = commonProps;

  const handleDownloadSepPartDetail = async () => {
    await exportSepPartsToExcel(sepPartsData, strategyNumber);
  };

  useEffect(() => {
    if (strategyNumber) {
      setIsLoading(true);
      getSepSpendGraphData(spendGraphData, strategyNumber)
        .then((result) => {
          setUpdatedSpendGraphData(result.spendData);
          setSepPartsData(result.parts || []);
          setErrorMessage(undefined);
        })
        .catch(() => {
          setErrorMessage(SEP_PLAN_TAB_LABELS.SEP_SPEND_ERROR_MESSAGE);
        })
        .finally(() => setIsLoading(false));
    }
  }, [strategyNumber, spendGraphData]);

  return (
    !isLoading && (
      <>
        <Card style={{ marginTop: '1rem', position: 'relative' }}>
          {isEdit && (
            <Box
              sx={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                zIndex: 1
              }}
            >
              <Tooltip
                title={
                  sepPartsData.length === 0
                    ? 'No SEP part data available to download'
                    : ''
                }
                placement="left"
              >
                <span>
                  <Button
                    variant={'tertiary'}
                    startIcon={<fuel-icon name={'download'} />}
                    onClick={handleDownloadSepPartDetail}
                    disabled={sepPartsData.length === 0}
                  >
                    Download SEP Part Detail
                  </Button>
                </span>
              </Tooltip>
            </Box>
          )}
          <SpendChartWrapper
            data={updatedSpendGraphData}
            chart_colors={CHART_COLORS}
            chart_datasets={CHART_DATASETS}
            rename_map={RENAME_MAP}
            userId={userId}
            title={SEP_PLAN_TAB_LABELS.SEP_SPEND_GRAPH_TITLE}
            titleTooltip={SEP_PLAN_TAB_LABELS.SEP_SPEND_GRAPH_TITLE_TOOLTIP}
            noSpendErrMsg={errorMessage}
            noSpendMsg={SEP_PLAN_TAB_LABELS.NO_SPEND_MESSAGE}
            singleLineLegend={true}
          />
        </Card>
        <SepSpendTable
          rows={transformSpendDataForTable(updatedSpendGraphData)}
          spendTypes={updatedSpendGraphData.map((column) => column.spendType)}
        />
      </>
    )
  );
};
